import { GridAction } from '@eforall/dashboard';
import { EmailJob } from '@interfaces';

export function getActions() {

	const actions: GridAction<EmailJob & { updatedUTC: number }>[] = [];

	return actions;
}